<script lang="ts">
    import {ModalDialogService} from 'shared/modal-dialogs';
    import {getInjector} from 'src/core';
    import type {Row} from '@tanstack/svelte-table';
    import type {HierarchicalRecordRow} from 'src/features/record-grid/lib/types';
    import type {FondFieldRelationLink} from 'src/features/record/kp-related-records-table/types';
    import type {RecordGridDataManager} from 'src/features/record-grid/lib/record-grid-data-manager';
    import {getRelationsContext} from 'src/features/record/kp-related-records-table/relations.context';
    import DefaultRowOptionsCell from 'src/features/record-grid/components/cells/DefaultRowOptionsCell.svelte';
    import KpDropdownMenuButton from 'shared/ui-widgets/dropdown-menu/KpDropdownMenuButton.svelte';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';
    import KpDropdownMenuItem from 'shared/ui-widgets/dropdown-menu/KpDropdownMenuItem.svelte';

    export let recordGridDataManager: RecordGridDataManager;
    export let row: Row<HierarchicalRecordRow>;

    const context = getRelationsContext();
    const modalDialogService = getInjector().getByClass(ModalDialogService);

    const rowRelations = context.relations.filter((relation) => relation.sourceFondId === row.original.fond.id);

    const onRelationClick = (relation: FondFieldRelationLink) => {
        modalDialogService.openModalWindow('fondFieldRelationTable',
            {relation, item: row.original},
            {size: 'lg'}
        );
    };
</script>

<DefaultRowOptionsCell {recordGridDataManager} {row}>
    {#if rowRelations.length > 0}
        <KpDropdownMenuButton buttonSize="xs">
            <svelte:fragment slot="button">
                <IconedContent icon="link"/>
            </svelte:fragment>

            <svelte:fragment slot="menu">
                {#each rowRelations as relation}
                    <KpDropdownMenuItem on:click={() => onRelationClick(relation)}>
                        <span class="relation-item">
                            <span class="relation-name">{relation.text}</span>
                            <small class="relation-label">Link na fond {relation.targetFondId} -> {relation.targetLinkFieldTypeId}</small>
                        </span>
                    </KpDropdownMenuItem>
                {/each}
            </svelte:fragment>
        </KpDropdownMenuButton>
    {/if}
</DefaultRowOptionsCell>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    .relation-item {
        display: flex;
        flex-direction: column;

        .relation-name {
            font-weight: 500;
        }

        .relation-label {
            color: @themed-text-muted;
            font-size: @font-size-small;
        }
    }
</style>